import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "id", label: "User Id" },
	{ key: "firstName", label: "First Name" },
	{ key: "middleName", label: "Middle Name" },
	{ key: "lastName", label: "Last Name" },
	{ key: "email", label: "Email Address" },
	{ key: "phoneNumber", label: "Mobile Phone" },
	{ key: "workphone", label: "Work Phone" },
	{ key: "extension", label: "Office Extension" },
	{ key: "region", label: "Region" },
	{ key: "department", label: "Department" },
	{ key: "role", label: "Role" },
	{ key: "unionName", label: "Union Name" },
	{ key: "phaseLevel", label: "Phase Level" },
	{ key: "hireDate", label: "Hire Date" },
	{ key: "quitDate", label: "Quit Date" },
	{ key: "ssn", label: "SSN" },
	{ key: "birthDay", label: "Birthday" },
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
	{ key: "projects", label: "Projects" },
	{ key: "assignments", label: "Assignments" },
	{ key: "purchases", label: "Purchases" },
	{ key: "perDiem", label: "Per Diem" },
	{ key: "newspaper", label: "Newspaper" },
	{ key: "fleets", label: "Fleets" },
	{ key: "reports", label: "Reports" },
	{ key: "personel", label: "Personel" },
	{ key: "calendar", label: "Calendar" },
	{ key: "timeOffs", label: "Time Offs" },
	{ key: "office", label: "Office" },
	{ key: "allOffice", label: "All Office" },
	{ key: "outside", label: "Outside" },
	{ key: "outsideStatus", label: "Outside Status" },
	{ key: "background", label: "Background" }
];
export default function UserExportForm(){
	return <ExportForm columns = {EXPORT_COLUMNS}/>;
}